module.exports = __webpack_public_path__ + "resources/img/img_ssl_ceritificate2_en.f25a34b6802335ac8a069d5f03c09989.png";